(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["book-choice"] && !Shopify.designMode) return;
  try {
    function initBookChoice(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = document.getElementById(root.dataset.formId);
    const choice = root.querySelector('[data-choice-input]');
    const themeInput = root.querySelector('[data-theme-input]');
    const bookInput = root.querySelector('[data-book-input]');
    const panel = root.querySelector('.book-choice__panel');
    const error = root.querySelector('.book-choice__error');
    const cards = root.querySelectorAll('.book-choice__card');
    const themeButtons = root.querySelectorAll('.book-choice__theme-btn');
    const lists = root.querySelectorAll('[data-theme-books]');

    function selectedMode() {
      const checked = root.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : 'surprise';
    }

    function sync() {
      const choosing = selectedMode() === 'choose';
      cards.forEach((card) => {
        card.classList.toggle('is-selected', card.querySelector('input').checked);
      });
      panel.hidden = !choosing;
      choice.value = choosing ? 'Je choisis mes goûts' : 'Surprends-moi';
      themeInput.disabled = !choosing;
      bookInput.disabled = !choosing;
      if (!choosing) {
        themeInput.value = '';
        bookInput.value = '';
        themeButtons.forEach((button) => button.classList.remove('is-selected'));
        root.querySelectorAll('[data-book]').forEach((button) => {
          if (button.tagName === 'BUTTON') button.classList.remove('is-selected');
        });
        lists.forEach((list) => {
          list.hidden = true;
        });
        error.hidden = true;
      }
    }

    root.addEventListener('change', sync);

    themeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        themeButtons.forEach((item) => item.classList.toggle('is-selected', item === button));
        themeInput.value = button.dataset.theme;
        bookInput.value = '';
        lists.forEach((list) => {
          list.hidden = list.dataset.themeBooks !== button.dataset.theme;
        });
        root.querySelectorAll('.book-choice__list button').forEach((item) => item.classList.remove('is-selected'));
        error.hidden = true;
      });
    });

    root.querySelectorAll('.book-choice__list button').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('.book-choice__list button').forEach((item) => {
          item.classList.toggle('is-selected', item === button);
        });
        bookInput.value = button.dataset.book;
        error.hidden = true;
      });
    });

    function guard(event) {
      if (selectedMode() !== 'choose') return;
      if (themeInput.value && bookInput.value) return;
      event.preventDefault();
      event.stopPropagation();
      error.hidden = false;
      panel.hidden = false;
    }

    if (form) {
      form.addEventListener('submit', guard, true);
      const button = form.querySelector('[type="submit"], .add-to-cart-button, button');
      if (button) button.addEventListener('click', guard, true);
    }

    sync();
  }

  function boot() {
    document.querySelectorAll('[data-book-choice]').forEach(initBookChoice);
  }

  boot();
  document.addEventListener('shopify:section:load', boot);
  } catch(e) { console.error(e); }
})();

})();
